<script setup lang="ts">
import { Bars3Icon } from '@heroicons/vue/24/outline'

withDefaults(
  defineProps<{
    drawerId?: string
  }>(),
  {
    drawerId: 'dashboard-sidebar-menu',
  },
)
</script>
<template>
  <div
    class="tw-daisy-navbar tw-min-h-[73px] tw-z-10 tw-border-base-200 tw-border-b tw-px-3"
  >
    <div class="tw-flex-none">
      <label
        :for="drawerId"
        class="tw-daisy-btn tw-daisy-btn-square tw-daisy-btn-ghost lg:tw-hidden"
      >
        <Bars3Icon class="tw-size-6" />
      </label>
    </div>
    <div class="tw-flex-1"></div>
    <div class="tw-flex-none tw-items-center">
      <CompaniesDropdown />
      <ThemeController />
      <ProfileDropdown />
    </div>
  </div>
</template>
